export default __webpack_public_path__ + "static/media/facebook.db22d166.svg";